// Single source of truth for outbound app links.
// One App Store ID everywhere: smart-app-banner, OG tags, every CTA.
export const APP_STORE_ID = '6757625289';
export const APP_STORE_URL = `https://apps.apple.com/us/app/crossed-paths-ai/id${APP_STORE_ID}`;

export const INSTAGRAM_URL = 'https://instagram.com/crossedpathsai';
export const SUPPORT_EMAIL = 'support@crossedpaths.ai';

// The microline under every primary CTA. Both clauses are verified.
// Never add version numbers, device claims, speed claims or ratings here.
export const CTA_MICROLINE = 'FREE TO TRY · PHOTOS NEVER LEAVE YOUR PHONE';
// Canonical copy-library string. Not "See your crossed paths" — that was a
// mis-citation; "discover" is the product's actual verb.
export const CTA_LABEL = 'Discover Your Crossed Paths';

// Identity encoding is sacred: GOLD = YOU · CORAL = THEM · PAPER = THE CROSSING.
// Colour never carries meaning alone — every use pairs a glyph and a word.
export const IDENTITY = {
  you: { glyph: '●', name: 'GOLD', word: 'YOU' },
  them: { glyph: '◆', name: 'CORAL', word: 'THEM' },
  crossing: { glyph: '✦', name: 'PAPER', word: 'THE CROSSING' },
};
